import { render } from "./AdminViewReports.vue?vue&type=template&id=9bf5a0ac"
import script from "./AdminViewReports.vue?vue&type=script&lang=js"
export * from "./AdminViewReports.vue?vue&type=script&lang=js"

import "./AdminViewReports.vue?vue&type=style&index=0&id=9bf5a0ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__